<template>
    <v-layout column fill-height>
        <breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Ajuda" descricao="Consulte regulamentações SUSEP, Manual de Boas-Práticas da Previsul, entre outros." :tabs="tabOptions" />

        <v-layout class="main">
            <Geral v-if="tab == 1" />
            <Documentos v-if="tab == 2" />
            <Contato v-if="tab == 3" />
        </v-layout>

    </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import Contato from "@/components/portal/ajuda/Contato";
import Documentos from "@/components/portal/ajuda/Documentos";
import Geral from "@/components/portal/ajuda/Geral";

export default {
  components: {
    breadcrumbs,
    Geral,
    Documentos,
    Contato
  },
  data() {
      return {
        tab:1,
        guia: "Ajuda > Geral",
        tabOptions: [
            { id: 1, titulo: "Perguntas Frequentes"},
            { id: 2, titulo: "Documentos"},
            { id: 3, titulo: "Contato"},
        ]    
      }
  },
  methods: {
      changeTab(value){
          this.tab = value;
          this.guia = "Ajuda > " + this.tabOptions[value - 1].titulo;
      }
  },
};
</script>